import { createContext, useContext } from 'react';

/**
 * A slot in the application shell's top bar.
 *
 * The original agent workspace put its project switcher in the top bar (to
 * the left of the date), while the manager page carries one in its page
 * head. The shared shell renders the top bar, so a page that needs a
 * top-bar control of its own publishes it here.
 */
export const ShellTopbarContext = createContext({
  setTopbarContent: () => {},
});

export function useShellTopbar() {
  return useContext(ShellTopbarContext);
}
